/**
 * @Author: 左建
 * @Date: 2022/12/7 14:56
 * @LastEditTime: 2022/12/7 14:56
 * @Description: 静态数据配置
*/
import store from "@/store"
// 选择抽题方式
export function getChooseQuesType(type = "org") {
    if (type === "system") {
        return Object.freeze([
            {
                label: "系统题库",
                value: "system",
                children: [{
                    label: "自主选题",
                    value: "custom"
                }, {
                    label: "随机抽题",
                    value: "random"
                }]
            }
        ])
    }
    return Object.freeze([
        {
            label: "机构题库",
            value: "org",
            children: [{
                label: "自主选题",
                value: "custom"
            }, {
                label: "随机抽题",
                value: "random"
            }]
        }
    ])
}
// "系统抽题",
// "系统抽题": ,
// "手工增题",
// "随机抽题",
// "随机组卷"
export function getTypeBox () {
    const platform = store.state.platform
    if (platform === "yixue") {
        return Object.freeze([{
            label: "机构抽题",
            toolTip: "机构自主组卷"
        }, {
            label: "系统抽题",
            toolTip: "系统已配题库"
        }, {
            label: "随机组卷",
            toolTip: "系统随机组卷，每位学员的试卷都不一致"
        }, {
            label: "手工增题",
            toolTip: "机构自主增加试题"
        }])
    }
    return [{
        label: "机构抽题",
        toolTip: "机构自主组卷"
    }, {
        label: "随机组卷",
        toolTip: "系统随机组卷，每位学员的试卷都不一致"
    }, {
        label: "手工增题",
        toolTip: "机构自主增加试题"
    }]
}
